/* Product page hardening.

   Client, 28 Jul call: the chat button overlaps add to cart, and add to cart
   goes out of bounds.

   Cause. The stock sticky bar decides visibility with an IntersectionObserver at
   threshold 1 on the main product form. A threshold of 1 can only ever fire when
   the whole target fits inside the viewport. Once the buy block grows past the
   viewport, which it does on a phone as soon as the dynamic checkout buttons and
   the quantity row are both present, the ratio never reaches 1, the bar is told to
   show and it never hides again. That is the bar sitting on top of the gallery
   with the real add to cart still visible underneath it.

   Fix. Drive it from scroll position against the real add to cart button, which
   cannot fail on a tall target, and hand the measured bar height to CSS so the
   Shopify Inbox launcher can sit above it instead of on top of it. */

(() => {
  const READY = () => {
    const bar = document.querySelector('.sticky-atc-bar');
    if (!bar) return;

    const inner = bar.querySelector('sticky-atc-bar');
    const productId = inner?.getAttribute('data-product-id');
    const form = document.querySelector(
      productId ? `.main-product-form[data-product-id="${productId}"]` : '.main-product-form'
    );
    if (!form) return;

    // Retire the stock observer so the two do not fight over the class.
    if (inner?.observer) {
      try { inner.observer.disconnect(); } catch { /* already gone */ }
    }

    let ticking = false;
    const update = () => {
      ticking = false;
      // Show only once the real buy button has actually left the top of the viewport.
      const past = form.getBoundingClientRect().bottom < 80;
      bar.classList.toggle('sticky-atc-bar--show', past);

      const height = bar.classList.contains('sticky-atc-bar--show') ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--anyra-sticky-atc-height', `${height}px`);
    };

    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    // The bar height changes when a variant with a longer title is picked.
    new ResizeObserver(onScroll).observe(bar);
    update();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', READY);
  } else {
    READY();
  }
})();
